import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { REPORTING_API_BASE_URL } from '../constants';
import { ReportTemplate } from '../models/report-template.model';
import { ReportingTemplateRequest } from '../models/reporting-template-request.model';

@Injectable({ providedIn: 'root' })
export class TemplateLibraryService {
  private route: string = `${REPORTING_API_BASE_URL}templates`;
  constructor(public _httpClient: HttpClient, @Inject('IS_CA_TEMPLATE') private readonly isCaTemplate: boolean) {}

  getTemplates(): Observable<ReportTemplate[]> {
    return this._httpClient.get<ReportTemplate[]>(this.route + '/get-all');
  }

  getTemplatesByReportType(reportType: string): Observable<ReportTemplate[]> {
    return this._httpClient.get<ReportTemplate[]>(`${this.route}/get-all?reportType=${reportType}`);
  }

  creatingTemplateRequest(templateData: ReportingTemplateRequest): Observable<number> {
    const createTemplateRequest = { ...templateData, isCaTemplate: this.isCaTemplate };
    return this._httpClient.post<number>(this.route + '/create', createTemplateRequest);
  }
}
